import { IState } from 'shared/store';
import { IMainPrice, IPurchaseTermsResponse } from 'shared/types/purchaseTerm/purchaseTermsV2';

export const selectExtraPrices = (state: IState): IPurchaseTermsResponse | null => {
  return state.newbuildingExtraPrices;
};

export const selectFullPaymentTerm = (state: IState): IMainPrice | undefined => {
  return state.newbuildingExtraPrices?.mainPrice;
};
